export const API_BASE_URL = process.env.NEXT_PUBLIC_API_BASE_URL;
export const APP_SECRET_KEY = process.env.NEXT_PUBLIC_APP_SECRET_KEY;

